/* GARAN-Label und Gewährleistungshinweis: kleine Hilfsfunktionen ohne Abhängigkeiten.
   1) Vergrößern-Dialoge: Hinweis als Bild; Label als Kopie des Inline-SVG oder nachgeladen
      über die Section Rendering API (Sektion garan-label-render)
   2) Warenkorb: vollständiges Label beim ersten Aufklappen nachladen
   3) Produktseite: Modell (SKU) und Hersteller beim Variantenwechsel aktualisieren */
(function () {
  'use strict';

  function openDialog(dialog) {
    if (!dialog) return;
    if (typeof dialog.showModal === 'function') {
      if (!dialog.open) dialog.showModal();
    } else {
      var img = dialog.querySelector('img');
      if (img) window.open(img.src, '_blank', 'noopener');
    }
  }

  function currentVariantId() {
    var select = document.querySelector('.product-grid__detail select[name="id"], form[action*="/cart/add"] select[name="id"]');
    return select ? select.value : '';
  }

  function withCurrentVariant(url) {
    var id = currentVariantId();
    return id ? url.replace(/([?&])variant=\d+/, '$1variant=' + id) : url;
  }

  function extractRendered(html) {
    var template = document.createElement('template');
    template.innerHTML = html;
    var rendered = template.content.querySelector('.garan-render');
    return rendered ? rendered.innerHTML : '';
  }

  /* Jede eingesetzte Kopie des Labels bekommt eigene IDs, damit Clip-Pfad-Verweise (url(#…)) nicht auf eine
     andere, evtl. unsichtbare Kopie zeigen (Tab-Module rendern doppelt; Dialoge liegen zusätzlich im DOM). */
  var copyCounter = 0;
  function uniquify(inner) {
    var m = inner.match(/data-garan-uid="([^"]+)"/);
    if (!m) return inner;
    var uid = m[1];
    var fresh = uid + 'x' + (++copyCounter);
    return inner.split('g' + uid + '-').join('g' + fresh + '-')
      .split('data-garan-uid="' + uid + '"').join('data-garan-uid="' + fresh + '"')
      .split('id="garan-' + uid + '"').join('id="garan-' + fresh + '"')
      .split('data-garan-zoom-label="garan-' + uid + '"').join('data-garan-zoom-label="garan-' + fresh + '"');
  }

  /* Label-Kopie aus einem vorhandenen Inline-SVG in den Dialog legen (IDs der Kopie umbenannt) */
  function fillLabelDialogFromSource(dialog, sourceId) {
    var body = dialog.querySelector('.garan-dialog__body');
    var source = document.getElementById(sourceId);
    if (!body || !source) return false;
    var svg = source.querySelector('svg');
    if (!svg) return false;
    var uid = source.getAttribute('data-garan-uid') || '';
    var html = svg.outerHTML;
    if (uid) html = html.split('g' + uid + '-').join('g' + uid + 'z-');
    body.innerHTML = html;
    body.setAttribute('data-garan-filled', 'source:' + sourceId + ':' + currentVariantId());
    return true;
  }

  /* Vollständiges Label per Section Rendering API nachladen */
  function fillLabelDialogFromUrl(dialog, url) {
    var body = dialog.querySelector('.garan-dialog__body');
    if (!body || !url) return;
    var finalUrl = withCurrentVariant(url);
    var key = 'url:' + finalUrl;
    if (body.getAttribute('data-garan-filled') === key) return;
    body.setAttribute('data-garan-filled', key);
    body.innerHTML = '<p class="garan__placeholder">Label wird geladen …</p>';
    fetch(finalUrl, { credentials: 'same-origin' })
      .then(function (response) { if (!response.ok) throw new Error(response.status); return response.text(); })
      .then(function (html) {
        var inner = extractRendered(html);
        if (!inner) throw new Error('GARAN: Label nicht gefunden');
        body.innerHTML = uniquify(inner);
      })
      .catch(function () {
        body.removeAttribute('data-garan-filled');
        body.innerHTML = '<p class="garan__placeholder">Das Label konnte nicht geladen werden. <a href="' + finalUrl.split('&')[0] + '">Seite neu laden</a></p>';
      });
  }

  /* 0) Vollständiges Label in Klapp-Tabs nachladen (Platzhalter [data-garan-full-label]).
        Ein Abruf je URL; das Ergebnis wird in alle passenden Container eingesetzt (das Tab-Modul
        gibt seinen Inhalt zweimal aus). Danach zeigt „Label vergrößern" die Kopie dieses Labels. */
  var fullLabelCache = {};
  function loadFullLabels() {
    var containers = document.querySelectorAll('[data-garan-full-label]:not([data-garan-full-loaded])');
    if (!containers.length) return;
    var byUrl = {};
    containers.forEach(function (container) {
      var url = withCurrentVariant(container.getAttribute('data-garan-full-label'));
      (byUrl[url] = byUrl[url] || []).push(container);
    });
    Object.keys(byUrl).forEach(function (url) {
      if (!fullLabelCache[url]) {
        fullLabelCache[url] = fetch(url, { credentials: 'same-origin' })
          .then(function (response) { if (!response.ok) throw new Error(response.status); return response.text(); })
          .then(function (html) {
            var inner = extractRendered(html);
            if (!inner) throw new Error('GARAN: Label nicht gefunden');
            return inner;
          });
      }
      fullLabelCache[url].then(function (inner) {
        byUrl[url].forEach(function (container) {
          container.innerHTML = uniquify(inner);
          container.setAttribute('data-garan-full-loaded', '1');
          var anchor = container.querySelector('.garan--full');
          var meta = container.parentNode ? container.parentNode.querySelector('.garan-meta [data-garan-zoom-label]') : null;
          if (anchor && meta) {
            if (!anchor.id) anchor.id = 'garan-full-' + Math.random().toString(36).slice(2, 8);
            meta.setAttribute('data-garan-zoom-label', anchor.id);
            /* Klick auf das Label öffnet ebenfalls den Dialog (statt zur EU-Seite zu springen) */
            anchor.setAttribute('data-garan-zoom-label', anchor.id);
            anchor.setAttribute('data-garan-dialog', meta.getAttribute('data-garan-dialog'));
          }
        });
        updateVariantData();
      }).catch(function (error) {
        /* Platzhalter (Kurzform) bleibt stehen; Ursache in der Konsole sichtbar machen */
        if (window.console && console.warn) console.warn('GARAN: vollständiges Label konnte nicht geladen werden', url, error);
      });
    });
  }
  /* Tab-Module bauen ihren Inhalt teils erst per JavaScript auf: neu erscheinende Platzhalter ebenfalls füllen */
  if (window.MutationObserver) {
    var pending = null;
    new MutationObserver(function () {
      if (pending) return;
      pending = window.setTimeout(function () { pending = null; loadFullLabels(); }, 100);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  /* 1) Dialoge */
  document.addEventListener('click', function (event) {
    var zoomLabel = event.target.closest('[data-garan-zoom-label]');
    if (zoomLabel) {
      var labelDialog = document.getElementById(zoomLabel.getAttribute('data-garan-dialog'));
      if (!labelDialog) return;
      event.preventDefault();
      var sourceId = zoomLabel.getAttribute('data-garan-zoom-label');
      var lazyUrl = zoomLabel.getAttribute('data-garan-lazy-url');
      var filled = false;
      if (sourceId) filled = fillLabelDialogFromSource(labelDialog, sourceId);
      if (!filled && lazyUrl) fillLabelDialogFromUrl(labelDialog, lazyUrl);
      openDialog(labelDialog);
      return;
    }
    var zoom = event.target.closest('[data-garan-zoom]');
    if (zoom) {
      openDialog(document.getElementById(zoom.getAttribute('data-garan-zoom')));
      return;
    }
    var close = event.target.closest('[data-garan-close]');
    if (close) {
      var parent = close.closest('dialog');
      if (parent) parent.close();
      return;
    }
    if (event.target.matches && event.target.matches('dialog.garan-dialog')) {
      event.target.close();
    }
  });

  /* 2) Nachladen im Warenkorb */
  document.addEventListener('toggle', function (event) {
    var details = event.target;
    if (!details || details.tagName !== 'DETAILS' || !details.open) return;
    var url = details.getAttribute('data-garan-lazy');
    if (!url || details.getAttribute('data-garan-loaded')) return;
    details.setAttribute('data-garan-loaded', '1');
    var panel = details.querySelector('.garan__panel');
    var placeholder = details.querySelector('.garan__placeholder');
    fetch(url, { credentials: 'same-origin' })
      .then(function (response) { if (!response.ok) throw new Error(response.status); return response.text(); })
      .then(function (html) {
        var inner = extractRendered(html);
        if (!inner || !panel) throw new Error('GARAN: Label nicht gefunden');
        var links = panel.querySelector('.garan__panel-links');
        panel.innerHTML = uniquify(inner);
        if (links) panel.appendChild(links);
      })
      .catch(function () {
        var fallback = details.getAttribute('data-garan-fallback') || '#';
        if (placeholder) {
          placeholder.innerHTML = '<a href="' + fallback + '">Label auf der Produktseite ansehen</a>';
        }
      });
  }, true);

  /* 3) Modell und Hersteller bei Variantenwechsel */
  function fill(template, data) {
    return template.replace(/%model%/g, data.model).replace(/%brand%/g, data.brand);
  }
  function updateVariantData() {
    var select = document.querySelector('.product-grid__detail select[name="id"], form[action*="/cart/add"] select[name="id"]');
    var mapNode = document.querySelector('script[data-garan-models]');
    if (!select || !mapNode) return;
    var models;
    try { models = JSON.parse(mapNode.textContent); } catch (error) { return; }
    var entry = models[select.value];
    if (!entry) return;
    var data = typeof entry === 'string' ? { model: entry, brand: '' } : entry;
    document.querySelectorAll('[data-garan-model]').forEach(function (node) {
      if (node.textContent !== data.model) node.textContent = data.model;
    });
    if (data.brand) {
      document.querySelectorAll('[data-garan-brand], [data-garan-brand-text]').forEach(function (node) {
        if (node.textContent !== data.brand) node.textContent = data.brand;
      });
      document.querySelectorAll('input[data-garan-property]').forEach(function (input) {
        var value = fill(input.getAttribute('data-garan-property'), data);
        if (input.value !== value) input.value = value;
      });
    }
    document.querySelectorAll('[data-garan-aria]').forEach(function (node) {
      var label = fill(node.getAttribute('data-garan-aria'), { model: data.model, brand: data.brand || '' });
      if (node.getAttribute('aria-label') !== label) node.setAttribute('aria-label', label);
    });
    /* Gefüllte Label-Dialoge veralten beim Variantenwechsel; beim nächsten Öffnen neu befüllen */
    document.querySelectorAll('.garan-dialog__body[data-garan-filled]').forEach(function (body) {
      body.removeAttribute('data-garan-filled');
    });
  }
  document.addEventListener('change', function (event) {
    if (event.target && event.target.matches && event.target.matches('select[name="id"], .js-product-form input, .js-product-form select, .product-options input, .product-options select')) {
      window.setTimeout(updateVariantData, 0);
    }
  });
  document.addEventListener('click', function (event) {
    if (event.target.closest('.product-grid__detail, .product-options, .js-product-form')) {
      window.setTimeout(updateVariantData, 60);
    }
  });
  window.addEventListener('popstate', function () { window.setTimeout(updateVariantData, 0); });
  function init() {
    updateVariantData();
    loadFullLabels();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
